import { Modal } from '@src/entities/Event/ui/components/Modal';
import { User } from '@src/entities/User/ui/components/User';
import { Button as ButtonComponent } from '@src/shared/ui/components/Button';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import React, { ReactNode, useState } from 'react';

type ButtonProps = {
  children: ReactNode;
  onClick?: () => void;
  refetch?: () => void;
};

/**
 * Button: Create
 *
 * Opens a modal popup containing a form to create a new event.
 *
 * @param children
 * @param handleClick
 * @param refetch
 * @constructor
 */
export function Button({ children, onClick: handleClick = () => {}, refetch = () => {} }: ButtonProps) {
  const [showModal, setShowModal] = useState(false);

  return (
    <ErrorHandler location="src/features/Events/Create/components/Button/Button.tsx">
      <User.Capability attributes={['create']} resource="Notifications:Events">
        <ButtonComponent
          before={<IconSymbol icon="add" />}
          css={{
            marginLeft: 'var(--abyss-space-md)',
          }}
          onClick={() => {
            setShowModal(true);
            handleClick();
          }}
          size="$sm"
          variant="outline"
        >
          {children}
        </ButtonComponent>
        <Modal action="create" isOpen={showModal} refetch={refetch} setIsOpen={setShowModal} />
      </User.Capability>
    </ErrorHandler>
  );
}
